<ng-container>
  @if (loadComplete) {
    <app-owner-well-info [application]="application" [form]="form?.get('ownerWellInfo')" [organization]="organization" (notesRequested)="handleNotesRequested($event)"></app-owner-well-info>
    <app-well-information [application]="application" [form]="form?.get('wellInfo')" [organization]="organization" (notesRequested)="handleNotesRequested($event)"></app-well-information>
    <app-casing-and-tubing [application]="application" [form]="form?.get('casingTubing')" [dataTypes]="dataTypes" (notesRequested)="handleNotesRequested($event)"></app-casing-and-tubing>
    <app-formations [form]="form?.get('formations')" [application]="application" [countedItems]="itemList" [methodTypes]="methods" (notesRequested)="handleNotesRequested($event)"></app-formations>
    <app-documentation [form]="form?.get('documentation')" [application]="application" [onBaseDocumentTypes]="onBaseDocumentTypes" [reportType]="reportType" (notesRequested)="handleNotesRequested($event)"></app-documentation>
    <app-user-updates [application]="application" [form]="form?.get('userUpdates')" [well]="well"></app-user-updates>
    <app-received-dates [application]="application" [reportType]="reportType" [form]="form?.get('receivedDates')" (notesRequested)="handleNotesRequested($event)"></app-received-dates>
    <app-certification [form]="form?.get('certifications')" [application]="application" [reportType]="reportType" (notesRequested)="handleNotesRequested($event)"></app-certification>
    <div class="grid-x grid-margin-x">
      <div class="large-12 medium-12 small-12 text-align-center">
        @if (!isApproved && !isInCorrections) {
          <span class="minor-margin-right">
            <button class="button" (click)="onReturn()">Return For Corrections</button>
          </span>
        }
        @if (!isApproved && !isInCorrections) {
          <span class="minor-margin-right">
            <button class="button" (click)="onAccept()">Accept</button>
          </span>
        }
        @if (!isApproved && !isInCorrections) {
          <span class="minor-margin-right">
            <button class="button" (click)="onSave()">Save for Later</button>
          </span>
        }
        <span>
          <button class="button" (click)="cancel()">Cancel</button>
        </span>
      </div>
    </div>
  } @else {
    <div class="grid-x">
      <div class="cell small-12 medium-12 large-12">
        <text-loader [text]="'Loading Application'" [run]="!loadComplete" [tickType]="'.'" [interval]="1000"></text-loader>
      </div>
    </div>
  }
</ng-container>

